import { render, staticRenderFns } from "./barTickAlign.vue?vue&type=template&id=52551662&scoped=true"
import script from "./barTickAlign.vue?vue&type=script&lang=js"
export * from "./barTickAlign.vue?vue&type=script&lang=js"
import style0 from "./barTickAlign.vue?vue&type=style&index=0&id=52551662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52551662",
  null
  
)

export default component.exports